import 'core-js/stable'
import 'regenerator-runtime/runtime';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.min.css';
require('moment/locale/fr');
import VueI18n from 'vue-i18n'

import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@mz/coreui-vue'
import {iconsSet as icons} from './assets/icons/icons.js'
import store from './store'
import VTooltip from 'v-tooltip'
import Toasted from 'vue-toasted';
import VuejsDialog from 'vuejs-dialog';
import MzRd from 'mz-rd';
import { locales } from '@/locales';
import { LanguageMixin } from '@/mixins/language';

import { BASE_URL } from '@/constants/config';
import {redirectIfNotAuthenticated} from "@/utils/request";

Vue.mixin(LanguageMixin)
Vue.use(VueI18n);
export const i18n = new VueI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: "en",
  messages: locales,
  silentTranslationWarn: true,
});
Vue.use(CoreuiVue);
Vue.use(VTooltip);
Vue.use(MzRd, {
  apiUrl: BASE_URL,
  tokenBearer: 'Bearer',
  tableClassess: "mz-table",
  handleRequestError: redirectIfNotAuthenticated,
  showFilterHelp: false,
  tableOptions: {
    texts: {
      noResults: "Aucun enregistrement correspondant trouvé",
      filterBy: "Filtrer par {column}",
      count: "Affichage de {from} à {to} lignes sur {count}|Affichage de {to} lignes sur {count}|",
      showPerPageText: "Montrer|résultats par page"
    },
  },
});
Vue.use(VuejsDialog);
Vue.use(Toasted, {
  iconPack: 'fontawesome',
  theme: 'toasted-primary',
  position: 'top-center',
  action: {
    text: 'Close',
    icon: 'close',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  },
});
window.alert = (message, additional = {}) => {
  Vue.toasted.show(message, {
    duration: 5000,
    ...additional,
  });
};

window.confirm = async (message) => {
  try {
    await Vue.dialog.confirm(message, {okText: 'Confirm', cancelText: 'Cancel'});
    return true;
  } catch {
    return false;
  }
};

Vue.config.performance = true;

Vue.prototype.$log = console.log.bind(console);

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
});
